module.exports = __webpack_public_path__ + "media/notification.2330629d.wav";